import React from "react";
import "../../Styles/certified/teamdetailing.css";

export default function TeamDetailing() {
  return (
    <>
      <div className="tds-certified-details-section">
        <div className="tds-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="tds-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="tds-certified-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="tds-certified-badge"
            />
            <div className="tds-certified-company-names">
              <a href="https://teamdetailing.com" target="_blank" rel="noopener noreferrer">
                <img src="/assets/teamdetailing/team.png" alt="Team Detailing Solutions Logo" className="tds-certified-company-logo" />
              </a>
              <h1 className="tds-certified-full-name">
                Team Detailing Solutions Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="tds-certified-details-right">
            <img
              src="/assets/teamdetailing/09b.jpg"
              alt="Team Detailing Solutions Office"
              className="tds-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="tds-certified-description">
          <h2>
            Why Team Detailing Solutions Private Limited is an Outstanding Workplaces
          </h2>
          <p>
            Team Detailing Solutions Private Limited is an Engineering/Detailing Process Outsourcing firm was FOUNDED by Mr. K. SRIDHAR (sree) in the year 2005 to cater to the growing demand for good quality drawings for the steel construction industry.ing and recognition ensures a thriving workplace environment.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="tds-certified-info-cards">
          <div className="tds-certified-info-card">
            <div className="tds-certified-info-title">COMPANY SIZE</div>
            <div className="tds-certified-info-value">205 Employees</div>
          </div>
          <div className="tds-certified-info-card">
            <div className="tds-certified-info-title">INDUSTRY</div>
            <div className="tds-certified-info-value">Engineering Service</div>
          </div>
          <div className="tds-certified-info-card">
            <div className="tds-certified-info-title">CONNECT</div>
            <div className="tds-certified-info-icons">
              <span className="tds-certified-icon-round">
                <a href="https://teamdetailing.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="tds-certified-icon-round">
                <a href="https://www.linkedin.com/company/teamdetailingsolutions" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              {/* <span className="tds-certified-icon-round">
                <a href="https://www.facebook.com/teamdetailing" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span> */}
              <span className="tds-certified-icon-round">
                <a href="https://www.youtube.com/@teamdetailingsolutions3330" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/youtube.png" alt="Instagram" />
                </a>
              </span>
              <span className="tds-certified-icon-round">
                <a href="https://twitter.com/TeamDetailingS1?t=x28QhyST-VXJSQu0QLM09A&s=09" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="tds-certified-info-card">
            <div className="tds-certified-info-title">LOCATION (HQ)</div>
            <div className="tds-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="tds-certified-recognition-section">
          <h2 className="tds-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="tds-certified-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="tds-certified-recognition-image"
            />
          </div>
          <div className="tds-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at TDS Section */}
        <div className="tds-certified-life-section">
          <h2 className="tds-certified-life-title">
            Life at Team Detailing Solutions Private Limited
          </h2>
          <div className="tds-certified-life-gallery">
            <div className="tds-certified-life-col">
              <img src="/assets/teamdetailing/IMG_20251209_152543.jpg" alt="Office 1" className="tds-certified-life-img" />
              <img src="/assets/teamdetailing/IMG_20251209_151313.jpg" alt="Meeting 1" className="tds-certified-life-img" />
            </div>
            <div className="tds-certified-life-col tds-certified-life-center">
              <img src="/assets/teamdetailing/09a.jpg" alt="Main Office" className="tds-certified-life-img tds-certified-life-img-large" />
            </div>
            <div className="tds-certified-life-col">
              <img src="/assets/teamdetailing/IMG_20251209_151544.jpg" alt="Office 2" className="tds-certified-life-img" />
              <img src="/assets/teamdetailing/IMG_20251209_151805.jpg" alt="Meeting 2" className="tds-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}